/* eslint-disable @typescript-eslint/no-unused-vars */
import { checkValue, LightenDarkenColor } from 'src/components/common/helper';

/**
 *
 * @param btnClass
 * @param bgColor
 * @param fontColor
 * @param fontSizeInfo - { fontSize, fontLineHeight }
 * @param fontWeight
 * @returns
 */
const setHeaderButtonFormat = (
  btnClass: string,
  bgColor: string,
  fontColor: string,
  fontSizeInfo: any,
  btnType: string // = 'primary'
) => {
  const darkenColor = checkValue(bgColor) ? LightenDarkenColor(bgColor, -0.1) : '';
  const { fontSize } = fontSizeInfo;

  let btnStyle = '';
  switch (btnType?.toLowerCase()) {
    case 'primary': {
      btnStyle = `${btnClass} {
        ${checkValue(bgColor) ? `background-color: ${bgColor};` : ``}
        ${checkValue(fontColor) ? `color: ${fontColor};` : ``}                        
        ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``} 
        display: block;         
      }      
      ${btnClass}: hover {
        ${darkenColor !== '' ? `background-color: ${darkenColor};` : ``}
      }`;
      break;
    }
    case 'secondary': {
      btnStyle = `${btnClass} {
        background-color: transparent;
        ${checkValue(bgColor) ? `border: 1px solid ${bgColor};` : ``}
        ${checkValue(fontColor) ? `color: ${fontColor};` : ``}      
        ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``}
        display: block; 
      }
      ${btnClass}: hover {
         ${darkenColor !== '' ? `border: 1px solid ${darkenColor};` : ``}
        }
      }`;
      break;
    }
    case 'tertiary': {
      btnStyle = `${btnClass} {
        background-color: transparent;
        border: 0px;
        text-decoration: underline;
        ${checkValue(fontColor) ? `color: ${fontColor};` : ``}       
        ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``}
        display: block; 
      }        
     `;
      break;
    }
    case 'no cta': {
      btnStyle = `${btnClass} { display: none; }`;
      break;
    }
    default: {
      break;
    }
  }
  return btnStyle;
};

const setButtonFormat = (
  btnClass: string,
  bgColor: string,
  fontColor: string,
  fontSizeInfo: any,
  btnType: string, // = 'primary'
  globalCTAStyle: any
) => {
  const { primaryColour, cTACopyColor, cTAStyle } = globalCTAStyle;

  bgColor = checkValue(bgColor) ? bgColor : primaryColour;
  btnType = checkValue(btnType) ? btnType : cTAStyle;
  fontColor = checkValue(fontColor) ? fontColor : cTACopyColor;
  const darkenColor = checkValue(bgColor) ? LightenDarkenColor(bgColor, -0.1) : '';
  const { fontSize } = fontSizeInfo;

  let btnStyle = '';
  switch (btnType?.toLowerCase()) {
    case 'primary': {
      btnStyle = `${btnClass} {
        ${checkValue(bgColor) ? `background-color: ${bgColor} !important;` : ``}
        ${checkValue(fontColor) ? `color: ${fontColor} !important;` : ``}                        
        /* ${checkValue(fontSize) ? `font-size: ${fontSize} !important;` : ``} */
        ${checkValue(bgColor) ? `border: 1px solid ${bgColor};` : ``}
        display: block;
        text-decoration: none;                     
      }      
      ${btnClass}: hover {
        ${darkenColor !== '' ? `background-color: ${darkenColor} !important;` : ``}
      }`;
      break;
    }
    case 'secondary': {
      btnStyle = `${btnClass} {
        background-color: transparent;
        ${checkValue(bgColor) ? `border: 1px solid ${bgColor} !important;` : ``}
        ${checkValue(fontColor) ? `color: ${fontColor} !important;` : ``}      
        /* ${checkValue(fontSize) ? `font-size: ${fontSize} !important;` : ``} */
        display: block;
        text-decoration: none;    
      }
      ${btnClass}: hover {
         ${darkenColor !== '' ? `border: 1px solid ${darkenColor} !important;` : ``}
        }
      }`;
      break;
    }
    case 'tertiary': {
      btnStyle = `${btnClass} {
        background-color: transparent;
        border: 0px;
        text-decoration: underline;
        ${checkValue(fontColor) ? `color: ${fontColor} !important;` : ``}       
        /* ${checkValue(fontSize) ? `font-size: ${fontSize} !important;` : ``} */
        display: block; 
      } 
      ${btnClass}: hover {
        background-color: transparent;
      }
      `;
      break;
    }
    case 'no cta': {
      btnStyle = `${btnClass} { display: none !important; } `;
      break;
    }
    default: {
      break;
    }
  }
  return btnStyle;
};

const setGlobalButton = (
  btnClass: string,
  bgColor: string,
  btnType: string,
  fontColor: string,
  fontSizeInfo: any,
  fontWeight: any
) => {
  const darkenColor = checkValue(bgColor) ? LightenDarkenColor(bgColor, -0.1) : '';
  const { fontSize } = fontSizeInfo;
  let btnStyle = '';
  btnType = !checkValue(btnType) ? 'primary' : btnType;

  switch (btnType?.toLowerCase()) {
    case 'primary': {
      btnStyle = `${btnClass} {
        ${bgColor !== '' ? `background-color: ${bgColor};` : ``}
        ${bgColor !== '' ? `border: 1px solid ${bgColor};` : ``}
        ${fontColor !== '' ? `color: ${fontColor};` : ``}
        ${fontWeight !== '' ? `font-weight: ${fontWeight} !important;` : ``}
        /* ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``} */
        display: block;
        text-decoration: none;   
      }      
      ${btnClass}: hover {
        ${darkenColor !== '' ? `background-color: ${darkenColor};` : ``}
      }`;
      break;
    }
    case 'secondary': {
      btnStyle = `${btnClass} {
        background-color: transparent;
        ${bgColor !== '' ? `border: 1px solid ${bgColor};` : ``}
        ${fontColor !== '' ? `color: ${fontColor};` : ``}
        ${fontWeight !== '' ? `font-weight: ${fontWeight} !important;` : ``}
        /* ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``} */
        display: block; 
        text-decoration: none;  
      }
      ${btnClass}: hover {
        ${darkenColor !== '' ? `border: 1px solid ${darkenColor};` : ``}
        }
      }`;
      break;
    }
    case 'tertiary': {
      btnStyle = `${btnClass} {
        background-color: transparent;
        border: 0px;
        text-decoration: underline;
        ${fontColor !== '' ? `color: ${fontColor};` : ``}
        ${fontWeight !== '' ? `font-weight: ${fontWeight} !important;` : ``}
        /* ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``} */
        display: block; 
      }        
     `;
      break;
    }
    case 'no cta': {
      btnStyle = `${btnClass} { display: none; }`;
      break;
    }
    default: {
      break;
    }
  }

  btnStyle += `${btnClass}.Primary,${btnClass}.primary { 
    ${bgColor !== '' ? `background-color: ${bgColor};` : ``}
    ${fontColor !== '' ? `color: ${fontColor};` : ``} 
    ${fontWeight !== '' ? `font-weight: ${fontWeight} !important;` : ``}
    ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``}
    ${bgColor !== '' ? `border: 1px solid ${bgColor};` : ``}
    display: block;
    text-decoration: none;                                 
  }
  ${btnClass}.secondary, ${btnClass}.Secondary { 
    background-color: transparent !important;
    ${bgColor !== '' ? `border: 1px solid ${bgColor};` : ``}
    ${fontColor !== '' ? `color: ${fontColor};` : ``} 
    ${fontWeight !== '' ? `font-weight: ${fontWeight} !important;` : ``}
    ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``} 
    display: block; 
    text-decoration: none;                               
  }
  ${btnClass}.tertiary,${btnClass}.Tertiary { 
    background-color: transparent  !important;
    border: 0px;
    text-decoration: underline !important;
    ${fontColor !== '' ? `color: ${fontColor};` : ``} 
    ${fontWeight !== '' ? `font-weight: ${fontWeight} !important;` : ``}
    ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``}
    display: block;                                   
  }
  ${btnClass}.nocta,${btnClass}.No.CTA { display: none; }
  ${btnClass}.Primary,${btnClass}.primary: hover { 
    ${
      darkenColor !== '' ? `background-color: ${darkenColor};` : ``
    }                                                       
  }
  ${btnClass}.secondary, ${btnClass}.Secondary: hover { 
    background-color: transparent !important; 
    ${
      darkenColor !== '' ? `border: 1px solid ${darkenColor};` : ``
    }                                                      
  }
  `;

  return btnStyle;
};

/**
 * set font format
 * @param fontSizeInfo | { fontsize, fontLineHeight }
 * @param fontweight
 * @param fontcolor
 * @returns
 */
const setFontFormat = (selector: string, fontSizeInfo: any, fontweight: any, fontcolor: any) => {
  const { fontSize, fontLineHeight } = fontSizeInfo;
  return `
          ${selector}{
            ${checkValue(fontSize) ? `font-size: ${fontSize} !important;` : ``}
            ${checkValue(fontLineHeight) ? `line-height: ${fontLineHeight} !important;` : ``} 
            /* ${checkValue(fontweight) ? `font-weight: ${fontweight};` : ``} */
            ${checkValue(fontcolor) ? `color: ${fontcolor} !important;` : ``} 
          }           
        `;
};

const setFontFormatHero = (selector: string, fontSizeInfo: any, fontweight: any, fontcolor: any) => {
  const { fontSize, fontLineHeight } = fontSizeInfo;
  return `
          ${selector}{
            ${checkValue(fontSize) ? `font-size: ${fontSize} !important;` : ``}
            ${checkValue(fontLineHeight) ? `line-height: ${fontLineHeight} !important;` : ``} 
            ${checkValue(fontweight) ? `font-weight: ${fontweight};` : ``} 
            ${checkValue(fontcolor) ? `color: ${fontcolor} !important;` : ``} 
          }           
        `;
};

const setGlobalHeading = (desktopFontSize: string, mobileFontSize: string, fontweight: any) => {
  const globalH2 = {    
    contentModule: {
      c: '.content-module h2',
      d: 'headlineCopySizeDesktop',
      m: 'headlineCopySizeMobile',
    },
    featuredContentModule: {
      c: '.featured-content .featured-content-wrapper .locationinfor h2',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile',
    },
    contentPanel: {
      c: '.contentpanel-content .contentpanel-wrapper .content-panel-card-top-heading',
      d: 'contentItemTitleCopySizeDesktop',
      m: 'contentItemTitleCopySizeMobile',
    },
    benefitsPanelModule: {
      c: '.benefits .benefits-wrapper .benefits-infor h2',
      d: 'headlineCopySizeDesktop',
      m: 'headlineCopySizeMobile',
    },
    mixedContentListing: {
      c: '.mixed-content .mixed-content-wrapper .description h2',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile',
    },
    hotelModule: {
      c: '.hotelwidget .hotelwidget-wrapper h2',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile',
    },
    promoContentModule: {
      c: '.promo-module h2',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile',
    },
    videoGalleryModule: {
      c: '.video-section-player h2',
      d: 'videoTitleCopySizeDesktop',
      m: 'videoTitleCopySizeMobile',
    },
    sweepstakesModule: {
      c: '.sweepstakes-header h2',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile',
    },
    articleEntryFormModule: {
      c: '.article-entry-form-section .article-entry-form-container h2.article-entry-form-title',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile'
    },
    videoMediaGalleryModule: {
      c: '.common-videogallery-warpper-big h2',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile'
    },
    packageDealsModule: {
      c: '.package-deals-section .package-deals-module-container h2',
      d: 'titleCopySizeDesktop',
      m: 'titleCopySizeMobile',
    },
    default: {
      c: '.product-integration-panel h2',
      d: 'heading2CopySizeDesktop',
      m: 'heading2CopySizeMobile',
    },
  };

  let gStyles = '';

  Object.keys(globalH2).forEach((key, value) => {
    const gKey = globalH2[key];
    const selector = gKey.c;
    const dFontSizeInfo = setFontSizeByModule(key, gKey.d, desktopFontSize);
    const mFontSizeInfo = setFontSizeByModule(key, gKey.m, mobileFontSize);

    const dFontSize = dFontSizeInfo?.fontSize;
    const dFontLineHeight = dFontSizeInfo?.fontLineHeight;

    const mFontSize = mFontSizeInfo?.fontSize;
    const mFontLineHeight = mFontSizeInfo?.fontLineHeight;

    gStyles += `${selector}{
                  ${checkValue(dFontSize) ? `font-size: ${dFontSize} !important;` : ``}
                  ${checkValue(dFontLineHeight) ? `line-height: ${dFontLineHeight} !important;` : ``} 
                  ${checkValue(fontweight) ? `font-weight: ${fontweight} !important;` : ``}       
                }
                @media only screen and (max-width: ${mediaQueries.tab}){
                  ${selector}{                
                    ${checkValue(mFontSize) ? `font-size: ${mFontSize} !important;` : ``}
                    ${checkValue(mFontLineHeight) ? `line-height: ${mFontLineHeight} !important;` : ``} 
                    ${checkValue(fontweight) ? `font-weight: ${fontweight} !important;` : ``}                 
                  } 
                }                
               `;
  });

  return gStyles;
};

const setGlobalHeading1 = (selector: string, fontSizeInfo: any, fontweight: any, fontcolor: any) => {
  const { fontSize, fontLineHeight } = fontSizeInfo;
  const { heading2CopySizeDesktop, heading2CopySizeMobile } = defaultModuleFontSizes.default;

  // Line height is apply only except default
  const isDefatultHeading =
    checkValue(fontLineHeight) &&
    !(`${heading2CopySizeDesktop.fontSize}px` == fontSize || `${heading2CopySizeMobile.fontSize}px` == fontSize);

  return `
          ${selector}{
            ${checkValue(fontSize) ? `font-size: ${fontSize};` : ``}
            ${isDefatultHeading ? `line-height: ${fontLineHeight} !important;` : ``} 
            ${checkValue(fontweight) ? `font-weight: ${fontweight};` : ``} 
            ${checkValue(fontcolor) ? `color: ${fontcolor};` : ``} 
          }           
        `;
};

const setModuleBackGround = (selector: string, backgroundColor: string, backgroundImage: string) => {
  return `
          ${selector}{
            ${backgroundColor !== '' ? `background-color: ${backgroundColor};` : ``}
            ${backgroundImage !== '' ? `background-image: url(${backgroundImage});background-size: cover` : ``}; 
          }   
        `;
};

const mediaQueries = {
  desktop: '1400px',
  desktopsmall: '1280px',
  tab: '1024px',
  tabmedium: '992px',
  tabsmall: '767px',
  mobile: '575px',
};

const defaultModuleFontSizes = {
  default: {
    heading2CopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 50,
    },
    heading2CopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 50,
    },
    cTACopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
    bookNowCopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
    wizardCopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
  },
  heroModule: {
    heroTitleCopySizeDesktop: {
      fontSize: 92,
      fontLineHeight: 102,
    },
    heroTitleCopySizeMobile: {
      fontSize: 52,
      fontLineHeight: 62,
    },
    heroSubTextCopySizeDesktop: {
      fontSize: 20,
      fontLineHeight: 34,
    },
    heroSubTextCopySizeMobile: {
      fontSize: 20,
      fontLineHeight: 32,
    },
  },

  contentModule: {
    headlineCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 50,
    },
    headlineCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 50,
    },
    descriptionCopySizeDesktop: {
      fontSize: 24,
      fontLineHeight: 34,
    },
    descriptionCopySizeMobile: {
      fontSize: 20,
      fontLineHeight: 34,
    },
  },

  featuredContentModule: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 50, //44 previous
    },
    titleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 50,
    },
    summaryCopySizeDesktop: {
      fontSize: 18,
      fontLineHeight: 27,
    },
    summaryCopySizeMobile: {
      fontSize: 18,
      fontLineHeight: 27,
    },
    cTACopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
    titleLabelCopySize: {
      fontSize: 24,
      fontLineHeight: 22,
    },
  },

  videoGalleryModule: {
    videoTitleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 50, // 36
    },
    videoTitleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 50,
    },
  },
  quoteModule: {
    quoteTextCopySizeDesktop: {
      fontSize: 64,
      fontLineHeight: 74,
    },
    quoteTextCopySizeMobile: {
      fontSize: 42,
      fontLineHeight: 50,
    },
  },
  contentPanel: {
    contentItemTitleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 50, // 36
    },
    contentItemTitleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 50,
    },
    contentItemDescCopySizeDesktop: {
      fontSize: 16,
      fontLineHeight: 26,
    },
    contentItemDescCopySizeMobile: {
      fontSize: 16,
      fontLineHeight: 26,
    },
    contentItemCtaCopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
  },
  benefitsPanelModule: {
    headlineCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 48,
    },
    headlineCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 50,
    },
    descriptionCopySizeDesktop: {
      fontSize: 20,
      fontLineHeight: 34,
    },
    descriptionCopySizeMobile: {
      fontSize: 18,
      fontLineHeight: 30,
    },
    cTACopySize: {
      fontSize: 12,
      fontLineHeight: 14,
    },
    benefitItemTitleCopySizeDesktop: {
      fontSize: 20,
      fontLineHeight: 24,
    },
    benefitItemTitleCopySizeMobile: {
      fontSize: 18,
      fontLineHeight: 24,
    },
  },
  mixedContentListing: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 48,
    },
    titleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 48,
    },
    summaryCopySize: {
      fontSize: 20,
      fontLineHeight: 32,
    },
    summaryCopySizeMobile: {
      fontSize: 20,
      fontLineHeight: 32,
    },
    contentTileLabelCopySizeDesktop: {
      fontSize: 24,
      fontLineHeight: 26,
    },
    contentTileLabelCopySizeMobile: {
      fontSize: 24,
      fontLineHeight: 26,
    },
  },
  hotelModule: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 56
    },
    titleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 48,
    },
    cTACopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
    hotelCardCtaCopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
  },
  promoContentModule: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 50, // 44
    },
    titleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 50,
    },
    cTACopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
  },
  bookingModule: {
    cTACopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
  },
  productIntegrationModule: {
    summaryCopySizeDesktop: {
      fontSize: 20,
      fontLineHeight: 32,
    },
    summaryCopySizeMobile: {
      fontSize: 20,
      fontLineHeight: 32,
    },
    productItemSummaryCopySizeDesktop: {
      fontSize: 18,
      fontLineHeight: 27,
    },
    productItemSummaryCopySizeMobile: {
      fontSize: 18,
      fontLineHeight: 27,
    },
    cTACopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
  },
  sweepstakesModule: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 52,
    },
    titleCopySizeMobile: {
      fontSize: 30,
      fontLineHeight: 38,
    },
    summaryCopySizeDesktop: {
      fontSize: 16,
      fontLineHeight: 26,
    },
    summaryCopySizeMobile: {
      fontSize: 14,
      fontLineHeight: 22,
    },
  },
  articleEntryFormModule: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 56,
    },
    titleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 48,
    },
  },
  videoMediaGalleryModule: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 56,
    },
    titleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 48,
    },
  },
  packageDealsModule: {
    titleCopySizeDesktop: {
      fontSize: 42,
      fontLineHeight: 56, 
    },
    titleCopySizeMobile: {
      fontSize: 40,
      fontLineHeight: 48,
    },
    cTACopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
    hotelCardCtaCopySize: {
      fontSize: 14,
      fontLineHeight: 14,
    },
  },
};

/**
 *
 * @param defatulFontSize
 * @param fontCopyType
 * @returns
 */
const getFontSize = (defatulFontSize, fontCopySizeType) => {
  const { fontSize, fontLineHeight } = defatulFontSize;
  const fontSizes = {
    xxx_small: Number(fontSize - 5),
    xx_small: Number(fontSize - 4),
    x_small: Number(fontSize - 3),
    small: Number(fontSize - 2),
    medium: Number(fontSize - 1),
    default: Number(fontSize),
    large: Number(fontSize + 1),
    x_large: Number(fontSize + 2),
    xx_large: Number(fontSize + 3),
    xxx_large: Number(fontSize + 4),
  };
  const getFont = fontSizes[fontCopySizeType];
  const calcFontSize = checkValue(getFont) ? getFont : fontSize;
  const lineHeight = getLineHeight(calcFontSize, fontSize, fontLineHeight);
  const calcFontLineHeight = checkValue(lineHeight) ? lineHeight : fontLineHeight;

  return {
    fontSize: `${calcFontSize}px`,
    fontLineHeight: `${Math.round(Number(calcFontLineHeight))}px`,
  };
};

const getLineHeight = (fontSize, defaultFontSize, defaultFontLineHeight) => {
  const lineHeight = fontSize * Number(defaultFontLineHeight / defaultFontSize);
  return checkValue(lineHeight) ? `${lineHeight}` : `${defaultFontLineHeight}`;
};

const setFontSizeByModule = (module, moduleFontCopy, fontCopyType) => {
  const defaultFontsize = defaultModuleFontSizes[module]?.[moduleFontCopy];
  return checkValue(defaultFontsize)
    ? getFontSize(defaultFontsize, fontCopyType)
    : {
        fontSize: '',
        fontLineHeight: '',
      };
};

const setFontSizeHeroModule = (textSize) => {
  let fontsizes = {};
  let temptextSize = 'medium';
  if (checkValue(textSize)) temptextSize = textSize.toLowerCase();

  const tempDesktop = heroHeadingSizes.desktop[temptextSize];
  const tempMobile = heroHeadingSizes.mobile[temptextSize];
  fontsizes = { desktop: tempDesktop };
  return { ...fontsizes, mobile: tempMobile };
};

const titleWeight = (isBold: string) => {
  return 700;
};

const subTextWeight = (isBold: string) => {
  return 500;
};

const buttonTextWeight = (isBold: string) => {
  return 500;
};

const copyWeight = (isBold: string) => {
  return 700;
};

const buttonTextSize = (globalFontSize, moduleFontSize) => {
  if (checkValue(moduleFontSize)) {
    return moduleFontSize;
  }
  return checkValue(globalFontSize) ? globalFontSize : moduleFontSize;
};

const textColorGlobal = {
  white: '#fff',
  dark: '#141D38',
};

const heroHeadingSizes = {
  desktop: {
    small: { fontSize: '82px', fontLineHeight: '84px' },
    medium: { fontSize: '92px', fontLineHeight: '94px' },
    large: { fontSize: '102px', fontLineHeight: '104px' },
  },
  mobile: {
    small: { fontSize: '42px', fontLineHeight: '44px' },
    medium: { fontSize: '52px', fontLineHeight: '54px' },
    large: { fontSize: '62px', fontLineHeight: '64px' },
  },
};

export {
  setButtonFormat,
  setHeaderButtonFormat,
  setGlobalButton,
  setGlobalHeading,
  setGlobalHeading1,
  mediaQueries,
  titleWeight,
  subTextWeight,
  buttonTextWeight,
  copyWeight,
  setFontFormat,
  setModuleBackGround,
  setFontSizeByModule,
  buttonTextSize,
  textColorGlobal,
  heroHeadingSizes,
  setFontSizeHeroModule,
  setFontFormatHero,
};
